import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined';
import {
  MobileDesignConfigClasses,
  MobileDesignConfigState
} from '../MobileDesignConfig.types';
import facebookIcon from '../../../assets/pictures/facebookIcon.png';
import instagramIcon from '../../../assets/pictures/instagramIcon.png';
import linkedinIcon from '../../../assets/pictures/linkedinIcon.png';
import { Input } from '../..';

interface LinkSectionProps {
  classes: MobileDesignConfigClasses;
  state: MobileDesignConfigState;
  onLinkChange: (field: 'url', value: string) => void;
  onSocialChange: (field: 'facebook' | 'instagram' | 'linkedin', value: string) => void;
}

export const LinkSection: React.FC<LinkSectionProps> = ({ classes, state, onLinkChange, onSocialChange }) => {
  const { facebook, instagram, linkedin, url } = state;

  return (
    <div>
      <p className={classes.designText}>Site web</p>
      <Input
        margin="dense"
        multiline
        id="url"
        type="text"
        variant="outlined"
        value={url || ''}
        onChange={e => onLinkChange('url', e.target.value)}
        className={classes.inputStyle}
        placeholder="https://www.webapp.fr/.."
        InputProps={{
          classes: {
            input: classes.resize
          },
          startAdornment: (
            <InputAdornment position="start">
              <LanguageOutlinedIcon style={{ opacity: 0.5 }} />
            </InputAdornment>
          )
        }}
      />
      <p className={classes.designText}>Facebook</p>
      <Input
        margin="dense"
        multiline
        id="facebook"
        type="text"
        variant="outlined"
        value={facebook || ''}
        onChange={e => onSocialChange('facebook', e.target.value)}
        className={classes.inputStyle}
        placeholder="https://www.facebook.com/.."
        InputProps={{
          classes: {
            input: classes.resize
          },
          startAdornment: (
            <InputAdornment position="start">
              <img src={facebookIcon} alt="displayImage" className={classes.iconOpacity} />
            </InputAdornment>
          )
        }}
      />
      <p className={classes.designText}>Instagram</p>
      <Input
        margin="dense"
        multiline
        id="instagram"
        type="text"
        variant="outlined"
        value={instagram || ''}
        onChange={e => onSocialChange('instagram', e.target.value)}
        className={classes.inputStyle}
        placeholder="https://www.instagram.com/.."
        InputProps={{
          classes: {
            input: classes.resize
          },
          startAdornment: (
            <InputAdornment position="start">
              <img src={instagramIcon} alt="displayImage" className={classes.iconOpacity} />
            </InputAdornment>
          )
        }}
      />
      <p className={classes.designText}>LinkedIn</p>
      <Input
        multiline
        margin="dense"
        id="linkedin"
        type="text"
        variant="outlined"
        value={linkedin || ''}
        onChange={e => onSocialChange('linkedin', e.target.value)}
        className={classes.inputStyle}
        placeholder="https://www.linkedIn.com/.."
        InputProps={{
          classes: {
            input: classes.resize
          },
          startAdornment: (
            <InputAdornment position="start">
              <img src={linkedinIcon} alt="displayImage" className={classes.iconOpacity} />
            </InputAdornment>
          )
        }}
      />
    </div>
  );
};

